'use client'
import { type FC, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { gtmDataLayerPush } from '../../gtm'
import { SeoHeadTitleMetas } from '../../seo'

import { ForgotPasswordRequestForm } from './ForgotPasswordRequestForm'
import { ForgotPasswordRequestNotification } from './ForgotPasswordRequestNotification'

export const ForgotPasswordRequestContent: FC = () => {
  const intl = useIntl()

  useEffect(() => {
    gtmDataLayerPush({
      event: 'forgotPassword',
    })
  }, [])

  return (
    <>
      <SeoHeadTitleMetas
        title={intl.formatMessage({
          id: 'general.link.label.password.forgotten',
        })}
      />
      <div
        className="flex min-w-fit flex-col items-center justify-center px-5"
        id="forgotpassword-form"
      >
        <ForgotPasswordRequestNotification />
        <section className="flex flex-col items-center justify-center pt-8">
          <h1 className="pb-3 text-center text-2xl font-normal text-dark-primary-max">
            <FormattedMessage id="forgotPassword.headline" />
          </h1>
          <ForgotPasswordRequestForm />
        </section>
      </div>
    </>
  )
}
